<script setup>
import SkeletonPlaceholder from '~/components/Base/SkeletonPlaceholder.vue'

// Fetch route
const route = useRoute()
const centerRoute = computed(() => route.params?.centerUid)

// Fetch Center Details
const { data: centerDetails, suspense: centerDetailSuspense, isPlaceholderData: isCenterDetailsPlaceholder } = useFetchCenterDetails(centerRoute.value)

// Prefetch data on the server side
onServerPrefetch(async () => {
    await centerDetailSuspense() // Wait for the query to finish fetching
})
</script>

<template>
    <div class="center-logo-header">
        <component
            :is="SkeletonPlaceholder"
            v-if="isCenterDetailsPlaceholder"
            :skeleton-placeholder-config="{ type: 'image', width: '250px', height: '100px' }"
        />

        <NuxtLinkLocale v-else :to="'centerUid'">
            <img
                :src="centerDetails?.logotype?.url"
                class="center-logo"
                :alt="centerDetails?.logotype?.altText || centerDetails?.centerName"
                height="44"
                width="250"
            >
        </NuxtLinkLocale>
    </div>
</template>

<style lang="scss">
.center-logo-header {
    display: flex;
    justify-content: center;
    margin-block-end: 40px;

    a {
        display: block;
    }
}

.center-logo {
    min-height: 50px;
    max-height: 150px;
    max-width: 150px;
    min-width: 50px;
    height: 100%;
    width: 100%;

    @include bp(large1) {
        max-width: 200px;
    }
}
</style>
